import { IPreferencesProvider } from 'smarthub-common'
import { LocalPreferencesProvider } from 'smarthub-providers'
import { IProps } from '../props'

export interface IPreferenceProviders {
  permanent: IPreferencesProvider
  temporary: IPreferencesProvider
}

export const preferences = (props: IProps): IPreferenceProviders => {
  const permanent = new LocalPreferencesProvider('session')
  const temporary = new LocalPreferencesProvider('session')

  return {
    permanent,
    temporary,
  }
}
